import React from "react";
import Footer from "../Fotter";
import bannerImage from "../assets/banner.jpg";
import Retrun from "../assets/refund-policy_large.avif";
import CancelOrder from "../assets/CancelMyOrder_large.avif";

const ReturnPolicy = () => {
  return (
    <div className=" min-h-screen flex flex-col">
      <header
        className="relative w-full bg-cover bg-center mt-3"
      // style={{ backgroundImage: `url(${bannerImage})` }}
      >
        <div className="container mx-auto text-left text-black relative pt-8 px-4 sm:px-8 md:px-16">
          <h1 className="text-3xl font-bold mb-4 text-shadow-lg text-left">
            RETURN POLICY
          </h1>
          <p className="text-xl font-medium opacity-90 text-left mx-auto">
            Our policy lasts 3 days. If 3 days have gone by since your purchase,
            unfortunately, we can’t offer you a refund or exchange.
          </p>
          <p className="text-xl font-medium opacity-90 max-w-xl text-left mt-9">
            Note – Please be informed that you have to pay for the return
            shipping fee. There is No Refund on Cash on Delivery (COD), you can
            only eligible for exchange with another product of the same price.
          </p>
        </div>
      </header>

      <main className="flex-grow mt-6">
        <section className=" bg-white">
          <div className="container mx-auto px-4 text-left md:px-12 lg:px-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-8 transition-all transform hover:scale-105">
              Requirements for Returns:
            </h2>
            <div className="text-lg text-gray-700 leading-relaxed space-y-6">
              <ul className="list-disc list-inside ">
                <li>
                  Must include a valid original purchase order number from
                  gws shopsy, purchases made outside of gws shopsy must contact
                  their seller for returns.
                </li>
                <li>
                  Complimentary items for prepaid orders will be given for
                  orders above Rs.799.
                </li>
                <li>
                  All returned products should be in the original packaging
                  without any missing contents.
                </li>
                <li>
                  If you want to return the product then 70% of your order
                  amount will be refunded as we deduct 30% for our courier and
                  packing charges (For Prepaid Orders Only).
                </li>
                <li>
                  Refund processes could take up to 6-8 working days after the
                  item is received.
                </li>
                <li>
                  We recommend adding a tracking number or delivery confirmation
                  with your shipment to ensure your return is received (highly
                  recommended for International returns).
                </li>
                <li>
                  There’s no refund on Tempered glass, only replacement can be
                  done if a defective one is received.
                </li>
                <li>
                  For Item purchased in “Super Deals” only replacement and
                  exchange can be done.
                </li>
              </ul>
              <p>
                To complete your return, we require a receipt or proof of
                purchase. Please contact our support team via
                info@gwsshopsy.com for more information.
              </p>
              <p className="font-bold">
                Please be informed that you have to pay for the return shipping
                fee.
              </p>
            </div>
          </div>
        </section>

        <section className="py-16 bg-gray-100">
          <div className="container mx-auto px-4 text-left md:px-12 lg:px-16">
            <img
              src={Retrun}
              alt="Visa"
              className="w-48 h-12 object-cover mb-6"
            />

            <div className="text-lg text-gray-700 leading-relaxed space-y-6">
              <p>
                Once your return is received and inspected, we will send you an
                email to notify you that we have received your returned item. We
                will also notify you of the approval or rejection of your
                refund. If you are approved, then your refund will be processed,
                and a credit will automatically be applied to your credit card
                or original method of payment, within a certain amount of days.
              </p>
              <p className="font-bold">NOTE- No Exchange & No Refunds on COD</p>
              <p>
                (We only replace items if they are defective, damaged or wrong
                item)
              </p>
              <p className="font-bold text-3xl">
                LATE OR MISSING REFUNDS (IF APPLICABLE)
              </p>
              <p>
                If you haven’t received a refund yet, first check your bank
                account again. Then contact your credit card company, it may
                take some time before your refund is officially posted. Next
                contact your bank. There is often some processing time (2-5
                business days) before a refund is posted.
              </p>
              <p>
                If you’ve done all of this and you still have not received your
                refund yet, please contact us at info@gwsshopsy.com.
              </p>
            </div>
          </div>
        </section>

        <section className="py-16 bg-white ">
          <div className="container mx-auto px-4 text-left md:px-12 lg:px-16">
            <img
              src={CancelOrder}
              alt="Visa"
              className="w-72 h-16 object-cover mb-6"
            />

            <div className="text-lg text-gray-700 leading-relaxed space-y-6 w-[90%] ms-3">
              <p>
                You can only cancel your order if your order has not been
                shipped. We will refund the 100% amount in 5-7 working days. If
                the order has been shipped, If it is shipped then please be
                informed that a management, processing and transaction fee (30%
                of your total order value) will be applied for the cancellation.
              </p>
              <h2 className="font-bold text-4xl text-left mt-8">Exchange</h2>
              <p className="font-bold">
                Don’t worry, if you ordered a wrong product / or want to
                exchange it
              </p>
              <ul className="list-disc mx-auto space-y-4 text-left">
                <li>
                  Send us the picture of the product you got, pleases make sure
                  it’s in original condition. You can WhatsApp (+91 8047154521)
                  or Email us info@gwsshopsy.com.
                </li>
                <li>
                  If we have sent you a Wrong Product by mistake then Reverse
                  Pickup will be done for free. Shipping of the replacement
                  product is also done for free.
                </li>
                <li>
                  If we have sent you the right product then Return shipping
                  will be at the buyer’s cost
                </li>
                <li>
                  As soon as the product is picked up from you, we dispatch the
                  replacement simultaneously (time to resolution reduced by 3
                  days).
                </li>
                <li>
                  Only One Time Replacement is Free after that you need to bear
                  the courier charges for both ways.
                </li>
                <p className="text-left mt-4 font-bold">
                  We only replace items if they are defective or damaged. If you
                  need to exchange it for the same item, send us an email at
                  info@gwsshopsy.com.
                </p>
              </ul>
            </div>
            <div className="mt-8 ">
              <h3 className="text-2xl font-medium text-gray-800">
                Contact Information
              </h3>
              <p className="text-lg text-gray-700 mt-2">
                <strong>Office and Warehouse Address:</strong>
              </p>
              <p className="text-lg text-gray-700">
                Shop No. 4, 105 Jai Bajrang Nagar Keladevi Road, Happy Tower In
                Front of King George School Dewas, Dewas Madhya Pradesh, 455001
              </p>
              <p className="text-lg text-gray-700 mt-2">
                <strong>Phone:</strong> +91 8047154521
              </p>
              <p className="text-lg text-gray-700 mt-2">
                <strong>Email:</strong> info@gwsshopsy.com
              </p>
              <p className="text-lg text-gray-700 mt-2">
                <strong>Website:</strong> www.gwsshopsy.com
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ReturnPolicy;
